import BaseSetup from '@/components/BaseSetup';

export type SharedAppAsideItemEmits = {};
export type SharedAppAsideItemProps = {
	stats?: boolean
	title?: string
	progress?: number | string
	progressColor?: Orion.Color
	icon?: string
	callback?: Function
};

export default class SharedAppAsideItemSetup extends BaseSetup {

	static readonly defaultProps = {};

	get progressIcon (): Orion.Icon {
		if (this.props.progressColor === 'success') {
			return 'trending_up';
		}
		else if (this.props.progressColor === 'danger') {
			return 'trending_down';
		}
		else {
			return 'arrow_right_md';
		}
	}

	constructor (
		private props: SharedAppAsideItemProps,
		private emits: SharedAppAsideItemEmits,
	) {
		super();
	}

}
